import TriImage from "./TriImage";
import BookingImage from "../img/booking.png";
import BookingImage1 from "../img/booking1.png";
import BookingImage3 from "../img/booking3.png";
import p1 from "../img/p1.png";
import p2 from "../img/p2.png";
import p3 from "../img/p3.png";
import p4 from "../img/p4.png";
import p5 from "../img/p5.png";
export default function FreeQuote(){
    const pgroup = [ p1, p2, p3, p4, p5 ]
    return <>
       <div className="FreeQuote mt-4 mt-lg-5 mb-2 mb-sm-5" >
           <div className="container" >
               <div className="quoteInner px-3 px-lg-5 ps-4 ps-lg-5 pt-3 pb-0" >
                   <div className="row" >
                       <div className="col-md-6 col-lg-5 pt-3" >
                           <h2 >Are you ready to Get Moving? Get your Free Quote! 😍</h2>
                           <p>Join with more 10 million+ Happy Customers</p>

                           <div className="peopleGroup mb-3 mb-sm-5 mb-lg-0" >
                                <div className="peopleGroup" >
                                { pgroup.map((m, i)=>{
                                    return <>
                                    <img key={i} src={m} className="img-fluid" alt="image" />
                                    </>
                                })}
                                </div>
                                <a href="Freequote" >Free Moving Quote</a>
                           </div>
                       </div>
                       <div className="col-md-6 col-lg-7" >
                       <TriImage mainclass=" " img1={BookingImage1}
                            img2={BookingImage}
                            img3={BookingImage3} />
                       </div>
                   </div>
               </div>
           </div>
       </div>
    </>
}